import { HttpModelConverter } from "src/app/modules/core/converter/httpModel.converter";
import { Injectable } from "@angular/core";
import { PrescriptionDefinitionModel } from "../prescriptionDefinition.model";
import { PrescriptionDefinitionSummaryConverter } from "./prescriptionDefinitionSummary.converter";
import { PrescriptionDefinitionLineSummaryConverter } from "./prescriptionDefinitionLineSummary.converter";

@Injectable({
    providedIn: 'root'
})
export class PrescriptionDefinitionConverter extends HttpModelConverter<PrescriptionDefinitionModel> {
    constructor(
        private prescriptionDefinitionSummaryConverter: PrescriptionDefinitionSummaryConverter,
        private prescriptionDefinitionLineSummaryConverter: PrescriptionDefinitionLineSummaryConverter
    ) {
        super();
    }
    protected createInstance(): PrescriptionDefinitionModel {
        return new PrescriptionDefinitionModel();
    }
    protected enrichObject(result: PrescriptionDefinitionModel, src: PrescriptionDefinitionModel) {
        result.summary = this.prescriptionDefinitionSummaryConverter.convert(src.summary);
        if (src.lines) {
            result.lines = src.lines.map(line => this.prescriptionDefinitionLineSummaryConverter.convert(line));
        }
    }
}